export default {"src":"/_next/static/media/shipping12.6ba85e88.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};